import React from "react";
import PropTypes from "prop-types";
import ReportsGrid from "shared/components/reportGrid/ReportsGridConnector";
import { pageBackgroundGray } from "theme/mainColors";

class ReportsOperations extends React.Component {

  componentWillMount() {
    this.props.reportsActions.fetchReports();
  }

  handlePageChange = (page, perPage) => {
    this.props.reportsActions.fetchReports(page, perPage);
  };

  handleDeleteReport = reportId => {
    const { page, perPage } = this.props.pageState;
    this.props.reportsActions.deleteReport(reportId, page, perPage);
  };

  render() {
    const { reports,  fetchingReports, generatingReport } = this.props;
    return (
      <ReportsGrid
        reportsListGridData={ reports }
        fetchingReports={ fetchingReports || generatingReport }
        showMoreActionsIcon={ true }
        backgroundColor={ pageBackgroundGray }
        onDeleteReport={ this.handleDeleteReport }
        showPagination={ true }
        onPageChange={ this.handlePageChange }
        totalItems={ this.props.pageState.totalEntries }
      />
    );
  }
}

ReportsOperations.propTypes = {
  fetchingReports: PropTypes.bool,
  pageState: PropTypes.object.isRequired,
  reports: PropTypes.arrayOf(PropTypes.object).isRequired,
  reportsActions: PropTypes.shape({
    fetchReports: PropTypes.func,
    deleteReport: PropTypes.func
  }).isRequired,
  generatingReport: PropTypes.bool
};

ReportsOperations.defaultProps = {
  fetchingReports: false
};

export default ReportsOperations;



// WEBPACK FOOTER //
// ./src/components/manageReports/comp/reportsOperations/ReportsOperations.js